import Swiper from 'swiper';
import { A11y, Autoplay, EffectFade, Pagination } from 'swiper/modules';

export default class ProjectsCarousel {
    constructor() {
        document.querySelectorAll('.js-projects-carousel').forEach((root) => {
            const el = root.querySelector('.js-projects-carousel__swiper');

            if (!el) return;

            new Swiper(el, {
                a11y: true,
                autoplay: {
                    delay: 8000,
                },
                effect: 'fade',
                fadeEffect: {
                    crossFade: true,
                },
                modules: [A11y, Autoplay, EffectFade, Pagination],
                pagination: {
                    clickable: true,
                    el: root.querySelector('.js-projects-carousel__pagination'),
                },
                slidesPerGroup: 1,
                slidesPerView: 1,
                speed: 2000,
            });
        });
    }
}
